var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M6.84226 0.727228C6.37448 0.258257 5.72113 0 5 0C4.27502 0 3.61951 0.256695 3.1539 0.722764C2.68324 1.19397 2.45392 1.83436 2.50776 2.52588C2.61449 3.89016 3.73249 4.99997 5 4.99997C6.26751 4.99997 7.38359 3.89038 7.492 2.52632C7.54656 1.84106 7.3158 1.202 6.84226 0.727228ZM9.23065 9.99994H0.769347C0.658596 10.0013 0.548917 9.97968 0.44829 9.9367C0.347662 9.89372 0.258617 9.83046 0.187632 9.75151C0.0313866 9.57807 -0.0315924 9.34124 0.0150409 9.10173C0.21792 8.05665 0.851076 7.17875 1.84624 6.56246C2.73035 6.01537 3.85027 5.71425 5 5.71425C6.14973 5.71425 7.26965 6.01559 8.15376 6.56246C9.14892 7.17853 9.78208 8.05643 9.98496 9.10151C10.0316 9.34102 9.96861 9.57785 9.81237 9.75128C9.74141 9.83028 9.65237 9.89358 9.55174 9.9366C9.45111 9.97961 9.34142 10.0013 9.23065 9.99994Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolder);
export default __webpack_public_path__ + "static/media/holder.6f09fcb90f0b0a205ab0ccf9fb02e8e3.svg";
export { ForwardRef as ReactComponent };